<template>
	<template v-if="data.active">
		<template v-if="item.availability_info?.status == '5' && item.date_available">
			<div v-if="data.id == 'p'" class="cp-tooltip-row in-stores">
				<div class="cp-tooltip-title">
					<strong>{{ labels.get('item_delivery_pickup') }}</strong>
				</div>
				<div class="cp-tooltip-desc">
					<span v-if="item.warehouses_single_pickup_display" v-html="labels.get('item_time_of_delivery_preorder_single').replace('%s%', item.warehouses_single_pickup_display.title).replace('%s2%', item.date_available)"></span>
					<span v-else v-html="labels.get('item_time_of_delivery_preorder').replace('%s%', item.date_available)"></span>
				</div>
			</div>
			<div v-else-if="['s', 'e', 'bb', 'bb_xxl', 'bb_fast'].includes(data.id)" class="cp-tooltip-row delivery" :class="{'bb-shipping': data.id == 'bb', 'delivery-premium': data.id == 'bb_fast'}">
				<div class="cp-tooltip-title">
					<span v-if="data.id == 's'" v-html="labels.get('item_delivery_standard_delivery')"></span>
					<span v-else-if="data.id == 'e'" v-html="labels.get('item_delivery_express_delivery')"></span>
					<span v-else-if="data.id == 'bb'" v-html="labels.get('item_delivery_bigbang_delivery')"></span>
					<span v-else-if="data.id == 'bb_xxl'" v-html="labels.get('item_delivery_bigbang_xxl_delivery')"></span>
					<span v-else-if="data.id == 'bb_fast'" v-html="labels.get('item_delivery_premium_title')"></span>
				</div>
				<div class="cp-tooltip-desc" v-html="labels.get('item_time_of_delivery_preorder').replace('%s%', item.date_available)"></div>
			</div>
		</template>
		<template v-else-if="item.availability_info?.status != '5'">
			<div v-if="['p', 's', 'e', 'bb', 'bb_xxl', 'bb_fast'].includes(data.id)" class="cp-tooltip-row delivery" :class="{'in-stores': data.id == 'p', 'bb-shipping': data.id == 'bb', 'delivery-premium': data.id == 'bb_fast'}">
				<div class="cp-tooltip-desc">
					<span v-if="data.id == 'p'">
						<span v-html="labels.get('item_delivery_pickup')"></span>
						<span v-if="item.warehouses_single_pickup_display" v-html="labels.get('item_delivery_pickup_single').replace('%s%', item.warehouses_single_pickup_display.title)"></span>
					</span>
					<span v-else-if="data.id == 's'" v-html="labels.get('item_delivery_standard_delivery')"></span>
					<span v-else-if="data.id == 'e'" v-html="labels.get('item_delivery_express_delivery')"> </span>
					<span v-else-if="data.id == 'bb'" v-html="labels.get('item_delivery_bigbang_delivery')"> </span>
					<span v-else-if="data.id == 'bb_xxl'" v-html="labels.get('item_delivery_bigbang_xxl_delivery')"> </span>
					<span v-else-if="data.id == 'bb_fast'" v-html="labels.get('item_delivery_premium').replace('%s%', fastShippingLocations)"> </span>

					<template v-if="data.id != 'bb_fast'">
						<span>&nbsp;</span>
						<span v-if="new Date(data.min_delivery_date * 1000).toDateString() === new Date().toDateString()" v-html="labels.get('item_time_of_delivery_today').replace('%s%', shippingDate)"></span>
						<span v-else-if="new Date(data.min_delivery_date * 1000).toDateString() === tomorrow.toDateString()" v-html="labels.get('item_time_of_delivery_tomorow').replace('%s%', shippingDate)"></span>
						<span v-else v-html="labels.get('item_time_of_delivery').replace('%s%', shippingDate)"></span>
					</template>
				</div>

				<div v-if="data.id == 'bb_fast' && labels.get('item_delivery_premium_note') != 'item_delivery_premium_note'" class="cp-tooltip-note" v-html="labels.get('item_delivery_premium_note')"></div>
			</div>
		</template>
	</template>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['data', 'item']);
	const {formatDate} = useText();

	//available fast shipping locations
	let fastShippingLocations = ref([]);
	if (props.item.shipping_options) {
		const bbFastOption = props.item?.shipping_options?.find(option => option.id === 'bb_fast');
		fastShippingLocations.value = bbFastOption ? bbFastOption?.fast_shipping_titles?.join(', ') : '';
	}

	//time of delivery
	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);

	const calendarMonth = ['januarja', 'februarja', 'marca', 'aprila', 'maja', 'junija', 'julija', 'avgusta', 'septembra', 'oktobra', 'novembra', 'decembra'];
	const calendarDays = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote'];
	const shippingDateDay = new Date(props.data.min_delivery_date * 1000).getDay();
	const shippingDateMonth = new Date(props.data.min_delivery_date * 1000).getMonth();
	let shippingDate = ref();

	if (calendarDays[shippingDateDay] && calendarMonth[shippingDateMonth]) {
		if (new Date(props.data.min_delivery_date * 1000).toDateString() === new Date().toDateString()) {
			shippingDate = new Date(props.data.min_delivery_date * 1000).getDate() + '.' + (new Date(props.data.min_delivery_date * 1000).getMonth() + 1) + '.';
		} else if (new Date(props.data.min_delivery_date * 1000).toDateString() === new Date(Date.now() + 86400000).toDateString()) {
			shippingDate = new Date(props.data.min_delivery_date * 1000).getDate() + '.' + (new Date(props.data.min_delivery_date * 1000).getMonth() + 1) + '.';
		} else {
			shippingDate = calendarDays[shippingDateDay] + ', ' + new Date(props.data.min_delivery_date * 1000).getDate() + '.' + (new Date(props.data.min_delivery_date * 1000).getMonth() + 1) + '.';
		}
	} else {
		shippingDate = new Date(props.data.min_delivery_date * 1000).toLocaleString('en-US', {weekday: 'short', day: 'numeric', month: 'long'});
	}
</script>

<style lang="less" scoped>
	.cp-tooltip-row {
		display: flex;
		justify-content: center;
		flex-direction: column;
		margin-bottom: 18px;
		padding-left: 32px;
		font-size: 12px;
		line-height: 1.3;
		color: @textColor;
		position: relative;
		&:last-child {
			margin-bottom: 0;
		}
		&.delivery:before {
			.icon-delivery();
			font: 17px/17px @fonti;
			color: @textColor;
			opacity: 0.8;
			position: absolute;
			left: 0;
		}
		&.delivery-premium:before {
			.icon-delivery-prime();
			font: 23px/23px @fonti;
			color: @textColor;
			opacity: 0.8;
			position: absolute;
			left: -2px;
		}
		&.in-stores:before {
			.icon-in-store();
			font: 21px/21px @fonti;
			color: @textColor;
			opacity: 0.8;
			position: absolute;
			left: 1px;
		}
		&.bb-shipping:before {
			.icon-bb-shipping();
			font: 17px/17px @fonti;
			color: @textColor;
			opacity: 0.8;
			position: absolute;
			left: 0;
		}

		@media (max-width: @t) {
			padding-left: 28px;
			font-size: 12px;
			&.delivery:before {
				font-size: 14px;
				line-height: 14px;
			}
			&.delivery-premium:before {
				font-size: 19px;
				line-height: 19px;
			}
			&.in-stores:before {
				font-size: 18px;
				line-height: 18px;
			}
			&.bb-shipping:before {
				font-size: 14px;
				line-height: 14px;
			}
		}
		@media (max-width: @ms) {
			margin-bottom: 10px;
			padding-left: 0;
			font-size: 10px;
			&:before {
				content: none !important;
			}
		}
	}
	.cp-tooltip-desc {
		font-weight: normal;
		&:first-letter {
			text-transform: capitalize;
		}
		:deep(p) {
			padding-bottom: 0;
		}
	}
	.cp-tooltip-note {
		font-size: 12px;
		margin-top: 2px;
		opacity: 0.8;

		@media (max-width: @t) {
			font-size: 11px;
		}
		@media (max-width: @ms) {
			font-size: 10px;
			margin-top: 1px;
		}
	}
	.cp-tooltip-empty {
		color: @textColor;
	}
</style>
